export default __webpack_public_path__ + "static/media/navigation-usage.903734fd.svg";